import * as React from "react"
import { Link, graphql } from "gatsby"

import Bio from "../components/bio"
import Layout from "../components/layout"
import Seo from "../components/seo"

const BlogIndex = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata?.title || `Title`
  // const posts = data.allMarkdownRemark.nodes
  const posts = data.allGraphCmsPost.nodes

  if (posts.length === 0) {
    return (
      <Layout location={location} title={siteTitle}>
        <Seo title="All posts" />
        <Bio />
        <p>
          No blog posts found. Add markdown posts to "content/blog" (or the
          directory you specified for the "gatsby-source-filesystem" plugin in
          gatsby-config.js).
        </p>
      </Layout>
    )
  }

  return (
    <Layout location={location} title={siteTitle}>
      <Seo title="All posts" />
      {/* <Bio /> */}
      {/* Blog Roll */}
      {/* <div className="relative flex flex-col mx-0 px-0 justify-between"> */}
      <div className="">
        <ol style={{ listStyle: `none` }}>
          {posts.map(post => {
            {
              /* const title = post.frontmatter.title || post.fields.slug */
            }
            const title = post.title || post.slug

            {
              /* <li key={post.fields.slug}> */
            }
            return (
              <li key={post.slug}>
                <article
                  className="post-list-item"
                  itemScope
                  itemType="http://schema.org/Article"
                >
                  <header>
                    <h2>
                      {/* <Link to={post.fields.slug} itemProp="url"> */}
                      {/* <Link to={"/posts/".concat(nextPost.slug)} rel="next"> */}
                      <Link
                        to={post.category.slug.concat("/", post.slug)}
                        itemProp="url"
                      >
                        <span itemProp="headline">{title}</span>
                      </Link>
                    </h2>
                    {/* <small>{post.frontmatter.date}</small> */}
                    <small>{post.date}</small>
                  </header>
                  <section>
                    <p
                      dangerouslySetInnerHTML={{
                        // __html: post.frontmatter.description || post.excerpt,
                        __html: post.description || post.excerpt,
                      }}
                      itemProp="description"
                    />
                  </section>
                </article>
              </li>
            )
          })}
        </ol>
      </div>
    </Layout>
  )
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }

    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      nodes {
        excerpt
        fields {
          slug
        }
        frontmatter {
          date(formatString: "MMMM DD, YYYY")
          title
          description
        }
      }
    }
    allGraphCmsPost(sort: { fields: date, order: DESC }) {
      nodes {
        id
        date: formattedDate
        excerpt
        slug
        title
        category {
          slug
        }
      }
    }
  }
`

// dbcLogo: file(
//   //   absolutePath: { regex: "/dbc-logo-1000x1000-Icon-Blue.svg/" }
//   // ) {
//   //   publicURL
//   // }
